import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { RefundSearchFormValues } from "./schema";

export interface RefundListQuery {
  readonly status: RefundSearchFormValues["status"];
  readonly method: RefundSearchFormValues["method"];
  readonly memberId?: number;
  readonly from: string;
  readonly to: string;
  readonly page: number;
  readonly size: number;
}

export async function getRefunds(
  apiClient: ApiClient,
  query: RefundListQuery,
  signal?: AbortSignal,
): Promise<Schemas["AdminPageRefundView"]> {
  const response = await apiClient.get<Schemas["AdminPageRefundView"]>(
    "/api/v1/admin/refunds/search",
    {
      query: {
        status: query.status || undefined,
        memberId: query.memberId,
        method: query.method || undefined,
        from: query.from || undefined,
        to: query.to || undefined,
        page: query.page,
        size: query.size,
      },
      signal,
      cache: "no-store",
    },
  );
  return response.data;
}

export async function executeRefund(
  apiClient: ApiClient,
  refundId: number,
  signal?: AbortSignal,
): Promise<Schemas["RefundView"]> {
  const response = await apiClient.post<Schemas["RefundView"]>(
    `/api/v1/admin/refunds/${refundId}/execute`,
    undefined,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function getRefundDetail(
  apiClient: ApiClient,
  refundId: number,
  signal?: AbortSignal,
): Promise<Schemas["RefundAdminDetailView"]> {
  const response = await apiClient.get<Schemas["RefundAdminDetailView"]>(
    `/api/v1/admin/refunds/${refundId}`,
    { signal, cache: "no-store" },
  );
  return response.data;
}

export async function findRefundForReconciliation(
  apiClient: ApiClient,
  refundId: number,
  query: Omit<RefundListQuery, "status" | "page" | "size">,
  signal?: AbortSignal,
): Promise<Schemas["RefundView"] | undefined> {
  void query;
  return (await getRefundDetail(apiClient, refundId, signal)).refund;
}
